import { Box, Button, Card, CardBody, CardHeader, Form, FormField, Heading, Layer, Select, Text, TextArea, TextInput } from "grommet"
import { Close } from "grommet-icons"
import { useEffect, useState } from "react"
import { useCreateDonateVariantMutation } from "../../../api/donateVariantsApi"
import { useDispatch } from "react-redux"
import { addNotification } from "../../../slices/notificationsSlice"
import { useTranslation } from "react-i18next"

const types = [
    { label: 'auctionLabel', value: 'AUCTION' },
    { label: 'rouletteLabel', value: 'ROULETTE' },
    { label: 'memesLabel', value: 'MEMES' },
]

const multiplierOptions = [
    { label: 'x1', value: 1 },
    { label: 'x2', value: 2 },
    { label: 'x3', value: 3 },
    { label: 'x4', value: 4 },
    { label: 'x5', value: 5 },
    { label: 'x6', value: 6 },
    { label: 'x7', value: 7 },
    { label: 'x8', value: 8 },
    { label: 'x9', value: 9 },
    { label: 'x10', value: 10 }
]

const titleValidationRules = [
    {
        regexp: /^.{3,255}$/,
        message: 'Title should be minimum 3 length and maximum 255 characters',
        status: 'error',
    }
]

const descriptionValidationRules = [
    {
        regexp: /^.{0,255}$/,
        message: 'Maximum 255 characters',
        status: 'error',
    }
]

export const DonateVariantCreateDialog = ({ show, onClose }) => {

    const { t } = useTranslation('donations', { useSuspense: false });

    const dispatch = useDispatch();

    const [createDonateVariant] = useCreateDonateVariantMutation();

    const [value, setValue] = useState();
    
    const handleSubmit = (value) => {
        if (value.type === 'AUCTION' || value.type === 'ROULETTE') {
            createDonateVariant({ ...value, ...{ cost: value.cost * 100 }})
            .unwrap()
            .then(response => {
                onClose();
                dispatch(addNotification({ show: true, message: 'Donate variant successfully created.', status: 'normal' }));
                setValue(undefined);
            })
            .catch(error => dispatch(addNotification({ show: true, message: 'Unable to create donate variant.', status: 'critical' })))
        } else if (value.type === 'MEMES') {
            createDonateVariant({ ...value, ...{ price: value.price * 100 }})
            .unwrap()
            .then(response => {
                onClose();
                dispatch(addNotification({ show: true, message: 'Donate variant successfully created.', status: 'normal' }));
                setValue(undefined);
            })
            .catch(error => dispatch(addNotification({ show: true, message: 'Unable to create donate variant.', status: 'critical' })))
        }
    }

    if (show) {
        return (
            <Layer onClickOutside={onClose}>
                <Card width={'medium'}>
                    <CardHeader justify="between" pad={{ left: 'medium', top: 'medium', right: 'medium' }}>
                        <Heading level={3} margin={'none'} weight={'bold'}>{t('createDonateVariant')}</Heading>
                        <Button icon={<Close />} onClick={onClose} />
                    </CardHeader>
                    <CardBody>
                        <Box>
                            <Form value={value} onChange={(nextValue) => setValue(nextValue)} onSubmit={({ value }) => handleSubmit(value)}>
                                <Box gap="small">
                                    <FormField label={t('typeLabel')} name="type" required={{ indicator: true }} >
                                        <Select id="type" name="type" placeholder={t('typeLabel')} options={types} labelKey={(option) => t(option.label)} valueKey={{ key: 'value', reduce: true }} />
                                    </FormField>
                                    <FormField label={t('titleLabel')} name="title" htmlFor="title" required={{ indicator: true }} validate={titleValidationRules}>
                                        <TextInput id="title" name="title" placeholder={t('titleLabel')} />
                                    </FormField>
                                    <FormField label={t('descriptionLabel')} name="description" validate={descriptionValidationRules}>
                                        <TextArea name="description" placeholder={t('descriptionLabel')} />
                                    </FormField>
                                    {value?.type === 'AUCTION' && <AuctionDonateVariantFormFields />}
                                    {value?.type === 'ROULETTE' && <RouletteDonateVariantFormFields />}
                                    {value?.type === 'MEMES' && <MemesDonateVariantFormFields />}
                                    <Box alignSelf="end">
                                        <Button label={t('createBtn')} primary type="submit" />
                                    </Box>
                                </Box>
                            </Form>
                        </Box>
                    </CardBody>
                </Card>
            </Layer>
        )
    }
}

const AuctionDonateVariantFormFields = () => {

    const { t } = useTranslation('donations');

    return (
        <FormField label={t('minAmountLabel')} name="cost" required={{ indicator: true }}>
            <TextInput id="cost" name="cost" placeholder="UAH" type="number" min={10} max={10000} />
        </FormField>
    )
}

const RouletteDonateVariantFormFields = () => {

    const { t } = useTranslation('donations');

    return (
        <FormField label={t('costSpinLabel')} name="cost" required={{ indicator: true }}>
            <TextInput id="cost" name="cost" placeholder="UAH" type="number" min={10} max={10000} />
        </FormField>
    )
}

const MemesDonateVariantFormFields = () => {

    const { t } = useTranslation('donations');

    return (
        <Box gap="small">
            <FormField label={t('memePriceLabel')} name="price" required={{ indicator: true }}>
                <TextInput id="price" name="price" placeholder="UAH" type="number" min={10} max={10000} />
            </FormField>
            <FormField label={t('fullscreenMemePriceLabel')} name="priceMultiplier" required={{ indicator: true }}>
                <Select id="priceMultiplier" name="priceMultiplier" placeholder={t('fullscreenMemePriceLabel')} options={multiplierOptions} labelKey="label" valueKey={{ key: 'value', reduce: true }} />
            </FormField>
        </Box>
    )
}